(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-resource-server-auth", [], factory);
	else if(typeof exports === 'object')
		exports["react-resource-server-auth"] = factory();
	else
		root["react-resource-server-auth"] = factory();
})(this, () => {
return 